import ReactCompareImage from 'react-compare-image';
import { motion } from 'framer-motion';

const BeforeAfterShowcase = () => {
  const projects = [
    {
      title: 'Luxury Apartment Kitchen',
      location: 'Visakhapatnam',
      before: 'https://images.pexels.com/photos/3926542/pexels-photo-3926542.jpeg?auto=compress&cs=tinysrgb&w=1260',
      after: 'https://images.unsplash.com/photo-1751591148854-49c2835dfaa1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1260',
      description: 'Complete modular kitchen transformation with premium fittings'
    },
    {
      title: 'Corporate Office Workspace',
      location: 'Hyderabad',
      before: 'https://images.pexels.com/photos/20988575/pexels-photo-20988575.jpeg?auto=compress&cs=tinysrgb&w=1260',
      after: 'https://images.unsplash.com/photo-1758630737900-a28682c5aa69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1260',
      description: 'Modern office interior with custom furniture and lighting'
    },
    {
      title: 'Residential Master Bedroom',
      location: 'Bangalore',
      before: 'https://images.pexels.com/photos/90319/pexels-photo-90319.jpeg?auto=compress&cs=tinysrgb&w=1260',
      after: 'https://images.unsplash.com/photo-1765279333918-949ddcb655ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1260',
      description: 'Elegant bedroom design with custom wardrobe systems'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="before-after-showcase">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">Transformations</p>
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight mb-4">
              Before & After Stories
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Drag the slider to see how we transform spaces with intelligent design and precision execution.
            </p>
          </motion.div>
        </div>

        <div className="space-y-16">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center"
              data-testid={`before-after-${index}`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="bg-white border border-slate-200 overflow-hidden shadow-lg">
                  <ReactCompareImage
                    leftImage={project.before}
                    rightImage={project.after}
                    sliderLineWidth={4}
                    sliderLineColor="#D4AF37"
                    handleSize={40}
                    hover={true}
                  />
                </div>
              </div>
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <p className="text-xs font-bold uppercase tracking-widest text-bronze-500 mb-3">{project.location}</p>
                <h3 className="text-3xl md:text-4xl font-semibold tracking-tight mb-4">{project.title}</h3>
                <p className="text-base leading-relaxed text-muted-foreground mb-6">{project.description}</p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-slate-50 p-4 border border-slate-200">
                    <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-1">Timeline</p>
                    <p className="text-lg font-semibold">45 Days</p>
                  </div>
                  <div className="bg-slate-50 p-4 border border-slate-200">
                    <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-1">Type</p>
                    <p className="text-lg font-semibold">Turnkey</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterShowcase;
